import { styled } from "goober";
import { PressButton } from "./PressButton";

export const ToggleGroup = styled("div")`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const ToggleButton = styled(PressButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  color: var(--text-primary);
  flex-shrink: 0;

  &:hover:not(:disabled) {
    background: var(--alpha4);
  }
  &:active:not(:disabled) {
    background: var(--alpha8);
  }

  & > * {
    transition: opacity var(--motion-fast) var(--ease-out);
  }
  &[aria-pressed="false"] > * {
    opacity: 0.4;
  }
  &[data-icon-crossfade][aria-pressed="false"] > * {
    opacity: 1;
  }
  &:disabled {
    cursor: default;
  }
  &:disabled > * {
    opacity: 0.3;
  }
`;

export const ToggleIconContainer = styled("span")`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  position: relative;
`;

export const ToggleIcon = styled("span")`
  position: absolute;
  display: flex;
  transition:
    opacity var(--motion-fast) var(--ease-out),
    transform var(--motion-fast) var(--ease-out);
`;
